import React from "react";
import { VoterApolloClient } from "../context/VoterApolloClient";

export const useVoterApolloClient = () => React.useContext(VoterApolloClient);
